module.exports = __webpack_public_path__ + "a0b160e04ecf38ac61330ab19aa705b2.png";